import { createSelector } from 'reselect'
import getProductVariantByIdProductUtil from 'modules/product/redux/utils/get-product-variant-by-id'
import getByUseItWithVariantIdDataProductsSelector from 'modules/product/redux/selectors/get-by-perfect-your-look-variant-id-data'

const getByUseItWithVariantIdProductSelector = variantId => createSelector(
  getByUseItWithVariantIdDataProductsSelector(variantId),
  /**
   * @param {GetGiftProductsResp} data
   */
  (data) => {
    return getProductVariantByIdProductUtil({
      variantId,
      data,
      isSingleProduct: true
    })
  }
)

export default getByUseItWithVariantIdProductSelector
